// extracted by mini-css-extract-plugin
module.exports = {"container":"FloatingToolbar_container__1aPg3","tooltip":"FloatingToolbar_tooltip__JOiZ5","single-icon":"FloatingToolbar_single-icon__e-Jrh"};